import {
  BonusStrategy,
  BonusType,
  BonusResult,
  ConfettiConfig,
  AmountConstraints,
} from '../interfaces/bonus.interface';

export class CdtRegaloBonusStrategy implements BonusStrategy {
  type = BonusType.CDT_REGALO;
  campaignSpecific = true; // Bono específico con valor de CDT regalo

  validateAmount(amount: number, extraParams?: { valorCdtRegalo?: number }): boolean {
    const valorCdt = extraParams?.valorCdtRegalo;
    return valorCdt ? amount === valorCdt : false;
  }

  calculateBonus(amount: number, termDays: number, extraParams?: { valorCdtRegalo?: number }): BonusResult {
    const valorCdt = extraParams?.valorCdtRegalo;
    const terms = this.getTermsAndConditions();
    if (!valorCdt) {
      return {
        isValid: false,
        bonusAmount: 0,
        message: '',
        confettiType: '',
        termsAndConditionsUrl: terms.url,
        termsAndConditionsDescription: terms.description,
      };
    }
    const bonusAmount = Math.round(valorCdt * (termDays / 360));
    const displayAmount = this.formatCurrency(bonusAmount);
    return {
      isValid: true,
      bonusAmount,
      message: `¡FELICIDADES! HAS GANADO UN <br class="d-none d-md-block"> CDT REGALO POR <b class="tag-bono-amt">${displayAmount}</b> 🎁`,
      message_simulador: `Tienes un CDT regalo de ${displayAmount} esperándote. Solo completa <b>la apertura de tu CDT</b> para obtenerlo.`,
      confettiType: 'celebration',
      displayAmount,
      bonusTag: 'cdt_regalo',
      amountLocked: false,
      lockedValue: valorCdt,
      minTermDays: [30, 60, 90, 180],
      tagNameBonusType: 'CDT_REGALO',
      termsAndConditionsUrl: terms.url,
      termsAndConditionsDescription: terms.description,
    };
  }

  getTermsAndConditions(): { url: string; description: string } {
    return {
      url: 'legal/bonos/cdt-regalo',
      description:
        'Para canjear un CDT Regalo de MejorCDT, debes ser el beneficiario de un bono especial y personalizado, asignado por la compañía en concursos, campañas o como aliado estratégico. Este bono es intransferible y su valor se convierte en el capital inicial de un Certificado de Depósito a Término (CDT) abierto a tu nombre, sin que necesites realizar una inversión con tu propio dinero. Para activarlo, es indispensable que seas mayor de edad y residente en Colombia, y que completes con éxito el proceso de registro y validación de identidad en la plataforma de MejorCDT. El CDT que se abrirá con el bono debe tener un plazo mínimo de 360 días (aproximadamente 12 meses), y solo podrás canjearlo dentro del plazo de vigencia que te fue notificado. Al final del plazo, recibirás el capital del bono más los rendimientos generados en tu cuenta bancaria personal. MejorCDT se reserva el derecho de anular el bono si detecta actividad fraudulenta o incumplimiento de los términos',
    };
  }

  getConfettiConfig(): ConfettiConfig {
    return {
      type: 'celebration',
      duration: 5000,
      intensity: 'heavy',
    };
  }

  getAmountConstraints(extraParams?: { valorCdtRegalo?: number }): AmountConstraints {
    const valorCdt = extraParams?.valorCdtRegalo;

    return {
      locked: true,
      value: valorCdt,
      minAmount: valorCdt,
      maxAmount: valorCdt,
    };
  }

  private formatCurrency(amount: number): string {
    return `$${amount.toLocaleString('es-CO')}`;
  }
}
